import { useCallback, useState } from 'react';

export const FORM_IDS = Object.freeze({
  TIME_OFF_REQUESTS: 'timeOffRequests',
  GEOFENCE: 'geofence',
  SHIFT_CHANGE_REQUEST: 'shiftChangeRequest',
  LATE_TO_SHIFT: 'lateToShift',
});

// This variable maps the notificationId that comes from the api to its
// corresponding form id
export const notificationFormIds = {
  1: FORM_IDS.TIME_OFF_REQUESTS,
  2: FORM_IDS.GEOFENCE,
  5: FORM_IDS.SHIFT_CHANGE_REQUEST,
  6: FORM_IDS.LATE_TO_SHIFT,
};

export const useFormValidation = () => {
  const [errors, setErrors] = useState({});

  // It is currently not possible to trigger an error as only checkboxes with
  // boolean values are used, but this is being placed here just in case we
  // need to add any validation logic in the future.
  const validationCallback = useCallback(() => {
    const error = null;

    return error;
  }, []);

  const errorContext = {
    errors,
    setError: (id, error) =>
      setErrors((prevErrors) => ({ ...prevErrors, [id]: error })),
  };

  return {
    errorContext,
    validationCallback,
    setErrors,
  };
};
